/**
 * Web stub for TurboModule spec files (SDK 54, Phase 3).
 *
 * react-native-web exports no TurboModuleRegistry, so a spec module imported by
 * web-reachable code breaks the Vite build. vite.config aliases the specific
 * `@/specs/Native*` modules that web-reachable services import to this stub —
 * the platform-specific native module is simply absent on web, which is exactly
 * what the consumers' null-guards expect (same behaviour NativeModules.X gave).
 *
 * If a NEW spec import ever enters the web bundle graph, Vite fails loudly at
 * build time ("TurboModuleRegistry is not exported…") — add that spec's alias
 * beside the existing ones in vite.config.
 */
export default null;
